export function capitalize(value: string): string {
  const [firstChar] = value;
  return firstChar === undefined ? '' : firstChar.toUpperCase() + value.slice(1);
}

export function uncapitalize(value: string): string {
  const [firstChar] = value;
  return firstChar === undefined ? '' : firstChar.toLowerCase() + value.slice(1);
}

export function snakeCaseToCamelCase(snake: string): string {
  const [first = '', ...rest] = snake.split('_');
  return [first, ...rest.map(v => capitalize(v))].join('');
}

export function camelCaseToSnakeCase(camelCase: string): string {
  return camelCase
    .replace(/(?<letter>[A-Z])/gu, ' $1')
    .split(' ')
    .join('_')
    .toLowerCase();
}

export function snakeCaseToPascalCase(snake: string): string {
  return snake
    .split('_')
    .map(v => capitalize(v))
    .join('');
}

export function pascalCase(str: string): string {
  return str
    .toLowerCase()
    .split(/[^a-z0-9]+/u)
    .map(s => capitalize(s))
    .join('');
}

export function snakeCase(str: string): string {
  return str
    .toLowerCase()
    .split(/[^a-z0-9]+/u)
    .join('_');
}
